import { useMemo } from "react";
import { useUsersWithArenaAccessQuery } from "~/graphql/supergraphHooks";
import { toDbId, toGlobalId } from "~/utils/graphql-helpers";

export type FormValues = {
  users: string[];
};

export const initialValues: FormValues = { users: [] };

export const useFetchUsersWithArenaAccess = ({ arenaIds }: { arenaIds?: number[] }) => {
  const arenaIdsGlobal = useMemo(() => {
    return arenaIds?.map((id) => toGlobalId("ArenaObjectType", id));
  }, [arenaIds]);

  const fetchUsersWithArenaAccessResult = useUsersWithArenaAccessQuery({
    variables: {
      filters: {
        arenaIds: arenaIdsGlobal ?? [],
      },
    },
    fetchPolicy: "network-only",
  });

  const rowData = useMemo(() => {
    return fetchUsersWithArenaAccessResult.data?.usersWithArenaAccess?.users.map((user) => ({
      id: toDbId(user.id),
      name: user.fullName ?? "--",
      email: user.emailAddress ?? "--",
    }));
  }, [fetchUsersWithArenaAccessResult.data]);

  return { users: rowData ?? [] };
};
